import { PropsWithChildren } from "react";

import {
  Button,
  Divider,
  Link,
  makeStyles,
  Typography
} from "@material-ui/core";

import { BsShieldSlash } from "react-icons/bs";

import AuthLayout from "modules/auth/components/AuthLayout";
import SelectAccount from "../SelectAccount";

import { useActiveAccount } from "modules/core/hooks/useActiveAccount";
import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";

import { redirectToSubdomain } from "modules/core/utils/helpers";

const useStyles = makeStyles(theme => ({
  inner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 15
  },

  icon: {
    color: theme.palette.secondary.main
  }
}));

const CheckAccountState = ({ children }: PropsWithChildren) => {
  const { activeAccount } = useActiveAccount();

  const { data: userData } = useAuthUserQuery();

  const classes = useStyles();

  if (!activeAccount?.is_active) {
    return (
      <AuthLayout
        title="Account Expired"
        img={
          <div className={classes.icon}>
            <BsShieldSlash size={80} />
          </div>
        }
      >
        <div className={classes.inner}>
          <Typography variant="body2" color="textSecondary">
            This account cannot be accessed as it is no longer active. For more
            information, contact your experimentation team lead. Alternatively,
            contact us at{" "}
            <Link href="mailto:info@efestra.com" color="textSecondary">
              info@efestra.com
            </Link>
          </Typography>

          {userData && userData.accounts.length > 1 ? (
            <>
              <Divider style={{ width: "100%" }} />

              <Typography variant="subtitle2">
                Switch to an alternative workspace
              </Typography>

              <SelectAccount
                accounts={userData.accounts.filter(acc => acc.is_active)}
                onSelect={subdomain => {
                  redirectToSubdomain(subdomain);
                }}
              />
            </>
          ) : null}

          <Button
            variant={
              userData && userData?.accounts.length > 1
                ? "outlined"
                : "contained"
            }
            color="secondary"
            component="a"
            href="https://www.efestra.com/pricing/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: 10 }}
            fullWidth
          >
            Checkout Our New Plans
          </Button>
        </div>
      </AuthLayout>
    );
  }

  return <>{children}</>;
};

export default CheckAccountState;
